import React from "react";
import SushiShopVideo from "@src/lib/render-video/SushishopVideo/SushishopVideo";
import type { SushiShopVideoElement } from "@src/lib/render-video/SushishopVideo/SushishopVideo";
import { landingStandardVideoBackgroundProps } from "design-system/src/Components/WidgetPart/LandingStandardMedia/landingStandardVideoBackgroundProps";
import { generateSushiShopImageUrl } from "@src/lib/render-image/generateSushiShopImageUrl";
import { ImageFit } from "@src/lib/render-image/interface/ImageData";

const wrapperStyle = { width: "100%", height: "100%" } as const;

export type LandingStandardSushiShopVideoExtras = Partial<{
  autoPlay: boolean;
  posterImageId?: string;
  /** Largeur CDN du poster CMS (défaut 1280). */
  posterImageWidth?: number;
  /** Si true (défaut) et pas de `posterImageId` : poster PNG export. Mettre false en mode ambient. */
  useVideoExportPoster?: boolean;
}>;

/** Rendu vidéo pour les composants `LandingStandard*` du design-system (`renderVideo`). */
export function renderLandingStandardSushiShopVideo(
  slug: string,
  videoControlRef?: React.Ref<SushiShopVideoElement | null>,
  extras?: LandingStandardSushiShopVideoExtras
): React.ReactNode {
  const rawPosterId = extras?.posterImageId?.trim();
  const hasValidPosterId =
    !!rawPosterId && rawPosterId !== "-1" && Number(rawPosterId) > 0;

  const customPosterUrl = hasValidPosterId
    ? generateSushiShopImageUrl({
        id: rawPosterId,
        fit: ImageFit.COVER,
        width: extras?.posterImageWidth ?? 1280,
        height: "auto",
      })
    : undefined;

  const exportPosterFallback =
    extras?.useVideoExportPoster !== false && !customPosterUrl;

  const showPosterLayer = Boolean(customPosterUrl) || exportPosterFallback;

  return (
    <SushiShopVideo
      ref={videoControlRef}
      slug={slug}
      {...landingStandardVideoBackgroundProps}
      autoPlay={
        extras?.autoPlay ?? landingStandardVideoBackgroundProps.autoPlay
      }
      poster={showPosterLayer}
      customPosterImage={customPosterUrl}
      wrapperStyle={wrapperStyle}
    />
  );
}
